export interface IData {
  _id: string;
 name: string;
  email: string;
  mobileNumber: string;
  description: string;
  file: string;
  enquiryType: EnquiryType;
  subject: string;
  companyName: string;
  departmentName: string;
  homePageUrl: string;
  postCode: string;
  prefectures: string;
  address: string;
  createdAt: string;
  updatedAt: string;
}
export enum EnquiryType {
  ENQUIRY = 1,
  PRODUCT_DETAILS = 2,
}
export interface ContactUsState {
  formData: IData;
  list: IData[];
  allList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
}

export type InitialState = ContactUsState;
